// /* eslint-disable */

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Divider,
  Grid,
  IconButton,
  List,
  ListItemButton,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { AddRounded, BusinessRounded, EditRounded } from '@mui/icons-material';
import ContractDetails from './ContractDetails';
import palette from '../../../theme/palette';
import Key from '../../../clientVariables.json';
import { useResponsiveStyles } from '../../../utils/responsiveStyles';
import { setContractsAction, setSelectedContractAction } from '../redux/action';

const ContractsData = ({ setAddContractOpen }) => {
  const currentUser = useSelector((state) => state.UserReducer.user);
  const contractsData = useSelector((state) => state.contractsManagement.contracts);
  const selectedContract = useSelector((state) => state.contractsManagement.selectedContract);
  // const [contractsData, setContractsData] = useState([]);
  const [statusList, setStatusList] = useState();
  const [customerDetailsData, setCustomerDetailsData] = useState(null);
  const styles = useResponsiveStyles();
  const [activeButton, setActiveButton] = React.useState('All');
  const dispatch = useDispatch();

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  useEffect(() => {
    getStatusList();
    getContracts();
    // if (customerData.length > 0) {
    //   // getCustomerDetails(customerData[0]?.userid);
    //   setCustomerDetailsData(customerData[0]);
    // }
  }, []);

  const getContracts = async () => {
    try {
      const response = await axios.get(`${Key.domain}/payment/contracts`);
      if (response.status === 200) {
        console.log('/payment/contracts response', response.data);
        // setContractsData(response.data.data);
        dispatch(setContractsAction(response.data.data));
        dispatch(setSelectedContractAction(response.data.data[0]));
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getStatusList = async () => {
    try {
      const response = await axios.get(`${Key.domain}/payment/contract/status_list`);
      if (response.status === 200) {
        setStatusList(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getStatusName = (statusID) => {
    const statusObj = statusList?.filter((data) => data.status_id === statusID)[0];
    return statusObj?.status_name;
  };

  // const getCustomerDetails = async (id) => {
  //   try {
  //     const response = await axios.post(`${Key.domain}/customer/get_customerdetails`, {
  //       customer_id: id,
  //     });
  //     if (response.status === 200) {
  //       setCustomerDetailsData(response.data.data);
  //       console.log(response.data.data);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const detailsHandler = (data, index) => {
    // getCustomerDetails(data?.userid);
    // setCustomerDetailsData(data);
    dispatch(setSelectedContractAction(data));
    console.log('details handler', data, index);
  };

  const addContractHandler = () => {
    setAddContractOpen(true);
  };

  const buttonStyles = (buttonName) => ({
    borderRadius: '0px',
    p: '4px 15px',
    color: activeButton === buttonName ? palette.primary.main : palette.grey[600],
    backgroundColor: activeButton === buttonName ? palette.primary.lighter : 'transparent',
    borderColor: palette.grey[400],
    '&:hover': {
      backgroundColor: activeButton === buttonName ? palette.primary.light : palette.primary.lighter,
      //   borderColor: activeButton === buttonName ? 'primary.dark' : 'primary.main',
    },
    fontSize: styles.fontSize12,
  });

  const text1Styles = {
    m: 0,
    fontSize: styles.fontSize12,
    fontWeight: 500,
    color: palette.grey[600],
  };

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Button
          variant="outlined"
          size="small"
          sx={{ mr: '8px' }}
          onClick={addContractHandler}
          startIcon={<AddRounded />}
        >
          Add Contract
        </Button>
        <ButtonGroup variant="outlined" aria-label="Basic button group" size="small" sx={{ mb: '6px' }}>
          <Button sx={buttonStyles('All')} onClick={() => handleButtonClick('All')}>
            All
          </Button>
          <Button sx={buttonStyles('Trail Period')} onClick={() => handleButtonClick('Trail Period')}>
            Trail Period
          </Button>
          <Button sx={buttonStyles('Monthly')} onClick={() => handleButtonClick('Monthly')}>
            Monthly
          </Button>
          <Button sx={buttonStyles('Yearly')} onClick={() => handleButtonClick('Yearly')}>
            Yearly
          </Button>
          <Button sx={buttonStyles('Custom')} onClick={() => handleButtonClick('Custom')}>
            Custom
          </Button>
        </ButtonGroup>
      </Grid>
      <Grid item xs={3.5}>
        {/* <Divider /> */}
        <Paper elevation={1} sx={{height: window.innerHeight - 100, overflow: 'scroll' }}>
          <List sx={{ pr: '4px' }}>
            {contractsData?.map((data, index) => (
              <ListItemButton
                onClick={() => detailsHandler(data, index)}
                selected={selectedContract?.customer_id === data?.customer_id}
                sx={{
                  borderBottom: '1px solid #ddd',
                  '.editButton': {
                    display: 'none',
                  },
                  '&:hover': {
                    '.editButton': {
                      display: 'block',
                    },
                  },
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                  <Box sx={{ display: 'flex', gap: '6px' }}>
                    <Avatar ><BusinessRounded /></Avatar>
                    <Box sx={{ width: '100', flexGrow: 1 }}>
                      <Box sx={{ display: 'flex', width: '100%' }}>
                        <Typography
                          paragraph
                          sx={{
                            flexGrow: 1,
                            m: 0,
                            fontWeight: 800,
                            fontSize: styles.fontSize16,
                            color: palette.grey[800],
                            textTransform: 'capitalize',
                          }}
                        >
                          {data?.company_name}
                        </Typography>
                        <Tooltip title="Edit Contract" followCursor>
                          <EditRounded
                            className="editButton"
                            // onClick={() => setEditCustomerData(data)}
                            sx={{
                              height: styles.icon20,
                              width: styles.icon20,
                              color: palette.grey[600],
                              bgcolor: '#fff',
                            }}
                          />
                        </Tooltip>
                      </Box>
                      {/* <Typography paragraph sx={{...text1Styles}}>
                        California City, California
                    </Typography> */}
                      <Typography paragraph sx={{ ...text1Styles }}>
                        {data?.email}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize9 }}>
                        Start Date
                      </Typography>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize13 }}>
                        {moment(data?.start_date).utc().format('LL')}
                      </Typography>
                    </Box>
                    <Box sx={{ border: '1px solid #ddd' }} />
                    <Box>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize9 }}>
                        Status
                      </Typography>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize13 }}>
                        {getStatusName(data?.contract_status)}
                      </Typography>
                    </Box>
                    <Box sx={{ border: '1px solid #ddd' }} />
                    <Box>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize9 }}>
                        Subscription Days
                      </Typography>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize13 }}>
                        {`${data?.duration} ${data?.period}`}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </ListItemButton>
            ))}
          </List>
        </Paper>
      </Grid>
      <Grid item xs={8.5}>
        <ContractDetails />
      </Grid>
    </Grid>
  );
};

export default ContractsData;
